import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import SelectWithLabelAsync from "../../../common/SelectWithLabelAsync"
import { notificationActions } from "../../../../store/notifications"
import Button from "../../../common/Button"
import { selectInsurance } from "../../../../lib/fetchApi"
import { insuranceActions } from "../../../../store/insurance"
import InsuranceSearchDone from "./InsuranceSearchDone"
import AsignInsurance from "./AsignInsurance"
import CreateLiability from "./CreateLiability"

import classes from '../attorney/AttorneyTabControls.module.css'
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"

const LiabilityTabControls = ({folder, apiCase}) => {
    let userPermissionDisabled = useUserTabEditPermissionDisabled(apiCase + '_assign')
    const dispatch = useDispatch()
    
    const userToken = useSelector(state => state.user.token)
    const isSearched = useSelector(state => state.insurance.searchResult)

    const [searchedAsyncValue, setSearchedAsyncValue] = useState(null)


    const searchLiabilityhandler = async (data) => {
        setSearchedAsyncValue(data)
        const insurance = await selectInsurance(userToken, data.value)
        
        if (insurance.status) {
            dispatch(notificationActions.setError(insurance))
        } else {
            dispatch(insuranceActions.setSearchResult(insurance))
        }
    }

    const clearFieldsHandler = () => {
        dispatch(insuranceActions.setSearchResult(null))
        dispatch(insuranceActions.setClearAsyncResults(true))

        dispatch(insuranceActions.removeinsuranceDataID())
    }

    return <div className={classes.controls}>  
        {!userPermissionDisabled && <>
            {!isSearched && <div className={classes.async_container}>
                <SelectWithLabelAsync label='Insurance Carriers' path={'insurance-carriers'} action={searchLiabilityhandler} maxWidth={165} minWidth={160}/>
                <SelectWithLabelAsync label={'Location'} path={'insurance-carrier-locations'} action={searchLiabilityhandler} maxWidth={165} minWidth={160}/>
            </div>}

            {isSearched && <>
                <InsuranceSearchDone searchedData={searchedAsyncValue}/>
            </>} 

            <Button btnStyle={'btn_light_grey'} click={clearFieldsHandler} title={'Clear'}><i className="ti ti-x"></i></Button>
            <AsignInsurance folder={folder} apiCase={apiCase}/>
        </>}

        <CreateLiability folder={folder} apiCase={apiCase} permission={'create_insurance'}/>
    </div>

}

export default LiabilityTabControls